require('./client-integrations/client-slack.js')
require('./lib/mfa.js')

$(document).ready(function () {
  $('form').submit(function () {
    $(this).find("button[type='submit']").prop('disabled', true)
    // $(this).find("button[type='submit']").removeClass('bg-primary')
    // $(this).find("button[type='submit']").addClass('bg-black')
    $(this).find("button[type='submit']").html('<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>')
  })

  window.bindClickFx()

  setTimeout(function () {
    $('.focus-after-delay').focus()
  }, 250)
})

window.bindClickFx = function () {
  $('.loader-on-click').on('click', function () {
    $(this).unbind('click')
    $(this).prop('disabled', true)
    $(this).html('<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>')
    $(this).on('click', function () { console.log('noop') } )
    return true
  })

  $('.loader-on-click-replace-icon').on('click', function () {
    $(this).unbind('click')
    $(this).prop('disabled', true)
    $(this).find('.bi').attr('class', 'spinner-border spinner-border-sm')
    $(this).on('click', function () { console.log('noop') } )
  })

  $('.date-locale').each(function () {
    var date = moment($(this).attr('data-date'))
    $(this).html(date.format('LLL'))
    $(this).attr('title', date.fromNow())
  })
}

window.setupCopyMagicEmail = function () {
  /* Get the text field */
  var copyText = document.getElementById('txtMagicEmail')

  /* Select the text field */
  copyText.select()
  copyText.setSelectionRange(0, 99999) /* For mobile devices */

  /* Copy the text inside the text field */
  navigator.clipboard.writeText(copyText.value)

  /* Alert the copied text */
  console.log(copyText.value)

  // document.getElementById('step_2').classList.remove('d-none')
  // $('#step_2').removeClass('d-none')
  $('#step_2').fadeIn('fast')
  setTimeout(function () {
    $('#btnNextStep').fadeIn('fast')
  }, 5000)
  return false
}

window.setupProceedToStep3 = function () {
  $('#step_3').fadeIn('fast')
  return false
}

window.startInvitationVerification = function () {
  window.Swal.fire({
    // title: "One moment - we're just checking this invitation...",
    html: '<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">One moment - we\'re just checking this invitation...</p><br/><br/><br/>',
    showConfirmButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })

  setTimeout(function () {
    window._syncInvitationWithApi()
  }, 250)
}

window._syncInvitationWithApi = function () {
  var invitationUrl = $('#txtInviteUrl').val() || ''
  $.post({
    url: '/services/verifyInvitation',
    data: {
      invitationUrl: invitationUrl
    },
    dataType: 'json'
  })
  .done(function (data) {
    data = _.defaultTo(data, {})
    const isSuccess = _.defaultTo(data.success, false)
    const errorMsg = _.defaultTo(data.error, '') || 'An unknown error occured.'
    if (isSuccess) {
      setTimeout(function () {
        Swal.fire({
          title: 'Success!',
          text: 'That invitation looks good to us 👍.\n\nLet\'s continue...',
          icon: 'success',
          showConfirmButton: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          allowEnterKey: false,
          timer: 3500,
          timerProgressBar: true
        }, function (result) {
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location = '/services/start?continue=1'
          }
        })
        setTimeout(function () {
          window.location = '/services/start?continue=1'
        }, 3600)
      }, 2000)
    } else {
      setTimeout(function () {
        Swal.fire({ title: 'Connection Error', text: errorMsg, icon: 'error' })
      }, 2000)
    }
  })
  .fail(function (xhr, status, err) {
    Swal.fire({ title: 'Connection Error', text: 'Error connecting to the AugerConnect server.', icon: 'error' })
  })
}

window.startDiscordWebhookVerification = function () {
  window.Swal.fire({
    html: '<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">One moment - we\'re just checking this Webhook URL...</p><br/><br/><br/>',
    showConfirmButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })

  setTimeout(function () {
    window._syncDiscordWebhookWithApi()
  }, 250)
}

window._syncDiscordWebhookWithApi = function () {
  var webhookURL = $('#txtWebhookUrl').val() || ''
  $.post({
    url: '/integrations/discord/verify',
    data: {
      webhookURL: webhookURL
    },
    dataType: 'json'
  })
  .done(function (data) {
    data = _.defaultTo(data, {})
    const isSuccess = _.defaultTo(data.success, false)
    const errorMsg = _.defaultTo(data.error, '') || 'An unknown error occured.'
    if (isSuccess) {
      const challengeToken = _.defaultTo(data.challengeToken, '')
      window.__challenge = challengeToken
      setTimeout(function () {
        window._showDiscordVerificationDialogue(null)
      }, 1000)
    } else {
      setTimeout(function () {
        Swal.fire({ title: 'Connection Error', text: errorMsg, icon: 'error' })
      }, 1000)
    }
  })
  .fail(function (xhr, status, err) {
    Swal.fire({ title: 'Connection Error', text: 'Error connecting to the AugerConnect server.', icon: 'error' })
  })
}

window._showDiscordVerificationDialogue = function (err) {
  var message = 'That Webhook looks good to us!'
  var icon = 'question'
  if (err) {
    icon = 'error'
    message = '😭 Oh no, that verification did not work.'
  }
  message += '\n\nWe\'ve sent a verification code to your channel, paste it below to complete the setup process.'
  setTimeout(function () {
    Swal.fire({
      title: 'Verification',
      text: message,
      icon: icon,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: false,
      willClose: false,
      showCancelButton: true,
      footer: 'Verification codes allow us to check that everything is working properly.',
      preConfirm: (input) => {
        var code = input.trim().toLowerCase().replace(/[^0-9a-z]/gi, '')
        console.debug(code)
        return fetch(`/integrations/discord/verify-challenge/${window.__challenge}/${code}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(response.statusText)
            }
            response.json().then(function (data) {
              if ((data.error || ''.length >= 1)) {
                Swal.showValidationMessage('Error: ' + data.error || '')
              } else {
                Swal.fire({
                  title: 'All Set!',
                  // icon: 'success',
                  text: 'Discord has now been successfully setup!',
                  showConfirmButton: false,
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  allowEnterKey: false,
                  timer: 5000,
                  timerProgressBar: true,
                  imageUrl: 'https://c.tenor.com/ysCzw9rCg0kAAAAi/floss-discord.gif'
                }).then((result) => {
                  if (result.dismiss === Swal.DismissReason.timer) {
                    window.location = '/services?integrationComplete=discord'
                  }
                })
                setTimeout(function () {
                  window.location = '/services?integrationComplete=discord'
                }, 5250)
              }
            })
            return false
          })
          .catch(error => {
            setTimeout(function () {
              window._showDiscordVerificationDialogue('Error')
            }, 250)
            return false
          })
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        const value = result.value
        Swal.showValidationMessage(
          `Request failed: ${value.error}`
        )
      }
      return true
    })
  }, 1)
}

window.handleServiceDisconnect = function (name, url) {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This will permanently disconnect your ' + name + ' integration. You will need to set this integration up from scratch again if you want to use ' + name + '.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, disconnect'
  }).then((result) => {
    if (result.isConfirmed) {
      window.Swal.fire({
        // title: "One moment - we're just checking this invitation...",
        html: '<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">Disconnecting Service Integration...</p><br/><br/><br/>',
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: false
      })
      $.post({
        url: url,
        data: {
        },
        dataType: 'json'
      })
      .done(function (data) {
        data = _.defaultTo(data, {})
        const isSuccess = _.defaultTo(data.success, false)
        const errorMsg = _.defaultTo(data.error, '') || 'An unknown error occured.'
        if (isSuccess) {
          Swal.fire({
            title: 'Disconnected!',
            icon: 'success'
          }).then(function () {
            window.location = '/services/augerconnect'
          })
        } else {
          Swal.fire({
            title: errorMsg || 'Could not disconnect!',
            icon: 'error'
          })
        }
      })
      .fail(function (xhr, status, err) {
        Swal.fire({ title: 'Connection Error', text: 'Error connecting to the AugerConnect server.', icon: 'error' })
      })
      
    }
  })
  return false
}

window.emailIntegrationAddUser = function () {
  Swal.fire({
    title: 'Invite Recipient',
    text: 'Enter an e-mail address. This user will receive e-mails when AugerConnect has updates about your content.',
    input: 'email',
    inputAttributes: {
      autocapitalize: 'off'
    },
    showConfirmButton: true,
    showLoaderOnConfirm: true,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false,
    willClose: false,
    showCancelButton: true,
    confirmButtonText: 'Invite',
    inputPlaceholder: 'turanga.leela@planetexpress.com',
    footer: '[Confidential] E-mails from AugerConnect may contain sensitive information about your content. Be sure that this recipient is trustworthy and is under NDA.',
    preConfirm: (input) => {
      var email = input.trim()
      return fetch(`/integrations/email/invite-member/${email}`).then(response => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }
          response.json().then(function (data) {
            if (((data.error || '').length >= 1)) {
              Swal.showValidationMessage('Error: ' + data.error || '')
            } else {
              Swal.fire({
                title: 'Invite sent!',
                icon: 'success',
                text: `Ask ${email} to check their emails (and be sure to check the spam folder too!). They will need to click a verification link for this e-mail address to become active on AugerConnect. ${email} will not receive notification e-mails until verification is complete.`,
                showConfirmButton: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                allowEnterKey: false
              }).then((result) => {
                window._showLoader()
                window.location = '/integrations/email?addedEmail=1'
              })
            }
          })
          return false
        })
        .catch(error => {
          alert(error)
          return false
        })
    },
  }).then(function (result) {
    if (result.isConfirmed) {
      const value = result.value
      Swal.showValidationMessage(
        `Request failed: ${value.error}`
      )
    }
    return true
  })
  return false
}

window.emailIntegrationRemoveUser = function (email) {
  Swal.fire({
    title: 'Remove member?',
    text: `${email} will no longer receive e-mail notifications.`,
    showConfirmButton: true,
    showLoaderOnConfirm: true,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false,
    willClose: false,
    showCancelButton: true,
    confirmButtonText: 'Remove Member',
    preConfirm: () => {
      return fetch(`/integrations/email/remove-member/${email}`, {
        method: 'POST'
      }).then(response => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }
          response.json().then(function (data) {
            if (((data.error || '').length >= 1)) {
              Swal.showValidationMessage('Error: ' + data.error || '')
            } else {
              Swal.fire({
                title: 'Removed!',
                text: `You have removed ${email}.`,
                icon: 'success'
              })
              var domId = window.sprintf('#email_%s', window.objectHash({ email: `${email}` }))
              $(domId).slideUp('fast')
            }
          })
          return false
        })
        .catch(error => {
          alert(error)
          return false
        })
    },
  }).then(function (result) {
    if (result.isConfirmed) {
      const value = result.value
      Swal.showValidationMessage(
        `Request failed: ${value.error}`
      )
    }
    return true
  })
  return false
}

window._showLoader = function (msg = '') {
  window.Swal.fire({
    html: window.sprintf('<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">%s</p><br/><br/><br/>', (msg || 'One moment...')),
    showConfirmButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })
}

window._dummyClick = function () {
  window.Swal.fire({
    title: 'This is just an example!',
    text: 'This is just a screenshot showing you where to click. You can\'t click buttons on this screenshot.',
    showConfirmButton: true,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })
  return false
}

window.didChangeIntegrationState = function (sender) {
  window.Swal.fire({
    html: '<br/><br/><br/><div class="spinner-border" role="status"></div><br/><br/><br/><p class="text-center">One moment - we\'re applying your settings...</p><br/><br/><br/>',
    showConfirmButton: false,
    allowEscapeKey: false,
    allowOutsideClick: false,
    allowEnterKey: false
  })
  setTimeout(function () {
    window.location = '/integrations/email'
  }, 2000)
}